import { api } from './api';
import type { RiskAssessmentConfig } from '../types/risk-assessment-config';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  error: null | { code: string; message: string };
}

export async function getRiskAssessmentConfigs() {
  const { data } = await api.get<ApiResponse<RiskAssessmentConfig[]>>(
    '/reports/risk-assessment-configs',
  );
  return data;
}

export async function getDefaultRiskAssessmentConfig() {
  const { data } = await api.get<ApiResponse<RiskAssessmentConfig>>(
    '/reports/risk-assessment-configs/default',
  );
  return data;
}

export async function getRiskAssessmentConfigById(configId: string) {
  const { data } = await api.get<ApiResponse<RiskAssessmentConfig>>(
    `/reports/risk-assessment-configs/${configId}`,
  );
  return data;
}
